import ReactGA from "react-ga4"; // Google Analytic


export default function GoogleAnalytics(action_a, category_a) {
    
    ReactGA.event({
        action:action_a,
        category:category_a,
    })
}